// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","footerIn":"Footer_footerIn__3_7Km","footerNav":"Footer_footerNav__2bDHs","menuColumn":"Footer_menuColumn__3ykzl"};